import { render } from "./ModalLogin.vue?vue&type=template&id=417c0cbe&scoped=true"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"

import "./ModalLogin.vue?vue&type=style&index=0&id=417c0cbe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417c0cbe"]])

export default __exports__